import { fetchWithAuth } from "@/http/config";
import { User } from "@/types/user";

function getUserInfo(): Promise<User> {
  return fetchWithAuth("/user/");
}

export { getUserInfo };
